"use strict";
// tslint:disable
// eslint-disable
/**
 * HEM Workbench API Specification
 * Health Economics Workbench API Specification
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItemsApi = void 0;
const runtime = require("../runtime");
const models_1 = require("../models");
/**
 * no description
 */
class ItemsApi extends runtime.BaseAPI {
    /**
     * Create new model item
     */
    createModelItemRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (process.env.NODE_ENV === "development" && (requestParameters.modelUuid === null || requestParameters.modelUuid === undefined)) {
                throw new runtime.RequiredError('modelUuid', 'Required parameter requestParameters.modelUuid was null or undefined when calling createModelItem.');
            }
            if (process.env.NODE_ENV === "development" && (requestParameters.type === null || requestParameters.type === undefined)) {
                throw new runtime.RequiredError('type', 'Required parameter requestParameters.type was null or undefined when calling createModelItem.');
            }
            if (process.env.NODE_ENV === "development" && (requestParameters.file === null || requestParameters.file === undefined)) {
                throw new runtime.RequiredError('file', 'Required parameter requestParameters.file was null or undefined when calling createModelItem.');
            }
            if (process.env.NODE_ENV === "development" && (requestParameters.path === null || requestParameters.path === undefined)) {
                throw new runtime.RequiredError('path', 'Required parameter requestParameters.path was null or undefined when calling createModelItem.');
            }
            const queryParameters = {};
            if (requestParameters.type !== undefined) {
                queryParameters['type'] = requestParameters.type;
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("oauthToken", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const consumes = [
                { contentType: 'multipart/form-data' },
            ];
            // @ts-ignore: canConsumeForm may be unused
            const canConsumeForm = runtime.canConsumeForm(consumes);
            let formParams;
            let useForm = false;
            // use FormData to transmit files using content-type "multipart/form-data"
            useForm = canConsumeForm;
            if (useForm) {
                formParams = new FormData();
            }
            else {
                formParams = new URLSearchParams();
            }
            if (requestParameters.file !== undefined) {
                formParams.append('file', requestParameters.file);
            }
            if (requestParameters.path !== undefined) {
                formParams.append('path', requestParameters.path);
            }
            if (requestParameters.fileTag !== undefined) {
                formParams.append('fileTag', requestParameters.fileTag);
            }
            const response = yield this.request({
                path: `/model/{modelUuid}/item/tag`.replace(`{${"modelUuid"}}`, encodeURIComponent(String(requestParameters.modelUuid))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: formParams,
            });
            return new runtime.TextApiResponse(response);
        });
    }
    /**
     * Create new model item
     */
    createModelItem(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.createModelItemRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Create new parameter model item
     */
    createParameterItemRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (process.env.NODE_ENV === "development" && (requestParameters.modelUuid === null || requestParameters.modelUuid === undefined)) {
                throw new runtime.RequiredError('modelUuid', 'Required parameter requestParameters.modelUuid was null or undefined when calling createParameterItem.');
            }
            if (process.env.NODE_ENV === "development" && (requestParameters.type === null || requestParameters.type === undefined)) {
                throw new runtime.RequiredError('type', 'Required parameter requestParameters.type was null or undefined when calling createParameterItem.');
            }
            if (process.env.NODE_ENV === "development" && (requestParameters.file === null || requestParameters.file === undefined)) {
                throw new runtime.RequiredError('file', 'Required parameter requestParameters.file was null or undefined when calling createParameterItem.');
            }
            if (process.env.NODE_ENV === "development" && (requestParameters.path === null || requestParameters.path === undefined)) {
                throw new runtime.RequiredError('path', 'Required parameter requestParameters.path was null or undefined when calling createParameterItem.');
            }
            if (process.env.NODE_ENV === "development" && (requestParameters.parameterName === null || requestParameters.parameterName === undefined)) {
                throw new runtime.RequiredError('parameterName', 'Required parameter requestParameters.parameterName was null or undefined when calling createParameterItem.');
            }
            const queryParameters = {};
            if (requestParameters.type !== undefined) {
                queryParameters['type'] = requestParameters.type;
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("oauthToken", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const consumes = [
                { contentType: 'multipart/form-data' },
            ];
            // @ts-ignore: canConsumeForm may be unused
            const canConsumeForm = runtime.canConsumeForm(consumes);
            let formParams;
            let useForm = false;
            // use FormData to transmit files using content-type "multipart/form-data"
            useForm = canConsumeForm;
            if (useForm) {
                formParams = new FormData();
            }
            else {
                formParams = new URLSearchParams();
            }
            if (requestParameters.file !== undefined) {
                formParams.append('file', requestParameters.file);
            }
            if (requestParameters.path !== undefined) {
                formParams.append('path', requestParameters.path);
            }
            if (requestParameters.fileTag !== undefined) {
                formParams.append('fileTag', requestParameters.fileTag);
            }
            if (requestParameters.parameterName !== undefined) {
                formParams.append('parameterName', requestParameters.parameterName);
            }
            const response = yield this.request({
                path: `/model/{modelUuid}/uploadFile`.replace(`{${"modelUuid"}}`, encodeURIComponent(String(requestParameters.modelUuid))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: formParams,
            });
            return new runtime.TextApiResponse(response);
        });
    }
    /**
     * Create new parameter model item
     */
    createParameterItem(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.createParameterItemRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Delete specified model item
     */
    deleteModelItemRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (process.env.NODE_ENV === "development" && (requestParameters.modelUuid === null || requestParameters.modelUuid === undefined)) {
                throw new runtime.RequiredError('modelUuid', 'Required parameter requestParameters.modelUuid was null or undefined when calling deleteModelItem.');
            }
            if (process.env.NODE_ENV === "development" && (requestParameters.itemUuid === null || requestParameters.itemUuid === undefined)) {
                throw new runtime.RequiredError('itemUuid', 'Required parameter requestParameters.itemUuid was null or undefined when calling deleteModelItem.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("oauthToken", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/model/{modelUuid}/item/{itemUuid}`.replace(`{${"modelUuid"}}`, encodeURIComponent(String(requestParameters.modelUuid))).replace(`{${"itemUuid"}}`, encodeURIComponent(String(requestParameters.itemUuid))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Delete specified model item
     */
    deleteModelItem(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.deleteModelItemRaw(requestParameters);
        });
    }
    /**
     * Get model help file
     */
    getModelHelpFileRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (process.env.NODE_ENV === "development" && (requestParameters.modelUuid === null || requestParameters.modelUuid === undefined)) {
                throw new runtime.RequiredError('modelUuid', 'Required parameter requestParameters.modelUuid was null or undefined when calling getModelHelpFile.');
            }
            if (process.env.NODE_ENV === "development" && (requestParameters.itemUuid === null || requestParameters.itemUuid === undefined)) {
                throw new runtime.RequiredError('itemUuid', 'Required parameter requestParameters.itemUuid was null or undefined when calling getModelHelpFile.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("oauthToken", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/model/{modelUuid}/downloadFile/{itemUuid}`.replace(`{${"modelUuid"}}`, encodeURIComponent(String(requestParameters.modelUuid))).replace(`{${"itemUuid"}}`, encodeURIComponent(String(requestParameters.itemUuid))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.BlobApiResponse(response);
        });
    }
    /**
     * Get model help file
     */
    getModelHelpFile(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getModelHelpFileRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Get specified model item
     */
    getModelItemRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (process.env.NODE_ENV === "development" && (requestParameters.modelUuid === null || requestParameters.modelUuid === undefined)) {
                throw new runtime.RequiredError('modelUuid', 'Required parameter requestParameters.modelUuid was null or undefined when calling getModelItem.');
            }
            if (process.env.NODE_ENV === "development" && (requestParameters.itemUuid === null || requestParameters.itemUuid === undefined)) {
                throw new runtime.RequiredError('itemUuid', 'Required parameter requestParameters.itemUuid was null or undefined when calling getModelItem.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("oauthToken", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/model/{modelUuid}/item/{itemUuid}`.replace(`{${"modelUuid"}}`, encodeURIComponent(String(requestParameters.modelUuid))).replace(`{${"itemUuid"}}`, encodeURIComponent(String(requestParameters.itemUuid))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.BlobApiResponse(response);
        });
    }
    /**
     * Get specified model item
     */
    getModelItem(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getModelItemRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Get specified model item history
     */
    getModelItemHistoryRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (process.env.NODE_ENV === "development" && (requestParameters.modelUuid === null || requestParameters.modelUuid === undefined)) {
                throw new runtime.RequiredError('modelUuid', 'Required parameter requestParameters.modelUuid was null or undefined when calling getModelItemHistory.');
            }
            if (process.env.NODE_ENV === "development" && (requestParameters.itemUuid === null || requestParameters.itemUuid === undefined)) {
                throw new runtime.RequiredError('itemUuid', 'Required parameter requestParameters.itemUuid was null or undefined when calling getModelItemHistory.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("oauthToken", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/model/{modelUuid}/item/{itemUuid}/history`.replace(`{${"modelUuid"}}`, encodeURIComponent(String(requestParameters.modelUuid))).replace(`{${"itemUuid"}}`, encodeURIComponent(String(requestParameters.itemUuid))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(models_1.ModelItemActionDTOFromJSON));
        });
    }
    /**
     * Get specified model item history
     */
    getModelItemHistory(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getModelItemHistoryRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Mark specific item as changelog file
     */
    markChangelogRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (process.env.NODE_ENV === "development" && (requestParameters.modelUuid === null || requestParameters.modelUuid === undefined)) {
                throw new runtime.RequiredError('modelUuid', 'Required parameter requestParameters.modelUuid was null or undefined when calling markChangelog.');
            }
            if (process.env.NODE_ENV === "development" && (requestParameters.itemUuid === null || requestParameters.itemUuid === undefined)) {
                throw new runtime.RequiredError('itemUuid', 'Required parameter requestParameters.itemUuid was null or undefined when calling markChangelog.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("oauthToken", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/model/{modelUuid}/item/{itemUuid}/changelog`.replace(`{${"modelUuid"}}`, encodeURIComponent(String(requestParameters.modelUuid))).replace(`{${"itemUuid"}}`, encodeURIComponent(String(requestParameters.itemUuid))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Mark specific item as changelog file
     */
    markChangelog(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.markChangelogRaw(requestParameters);
        });
    }
    /**
     * Unmark specific item as changelog file
     */
    unmarkChangelogRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (process.env.NODE_ENV === "development" && (requestParameters.modelUuid === null || requestParameters.modelUuid === undefined)) {
                throw new runtime.RequiredError('modelUuid', 'Required parameter requestParameters.modelUuid was null or undefined when calling unmarkChangelog.');
            }
            if (process.env.NODE_ENV === "development" && (requestParameters.itemUuid === null || requestParameters.itemUuid === undefined)) {
                throw new runtime.RequiredError('itemUuid', 'Required parameter requestParameters.itemUuid was null or undefined when calling unmarkChangelog.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("oauthToken", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/model/{modelUuid}/item/{itemUuid}/changelog`.replace(`{${"modelUuid"}}`, encodeURIComponent(String(requestParameters.modelUuid))).replace(`{${"itemUuid"}}`, encodeURIComponent(String(requestParameters.itemUuid))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Unmark specific item as changelog file
     */
    unmarkChangelog(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.unmarkChangelogRaw(requestParameters);
        });
    }
    /**
     * Update the specified fileTag associated with file
     */
    updateFileTagRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (process.env.NODE_ENV === "development" && (requestParameters.fileTagDTO === null || requestParameters.fileTagDTO === undefined)) {
                throw new runtime.RequiredError('fileTagDTO', 'Required parameter requestParameters.fileTagDTO was null or undefined when calling updateFileTag.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("oauthToken", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/tag/filetag/`,
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.FileTagDTOToJSON(requestParameters.fileTagDTO),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(models_1.FileTagUpdatedDTOFromJSON));
        });
    }
    /**
     * Update the specified fileTag associated with file
     */
    updateFileTag(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.updateFileTagRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Update specified model item
     */
    updateModelItemRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (process.env.NODE_ENV === "development" && (requestParameters.modelUuid === null || requestParameters.modelUuid === undefined)) {
                throw new runtime.RequiredError('modelUuid', 'Required parameter requestParameters.modelUuid was null or undefined when calling updateModelItem.');
            }
            if (process.env.NODE_ENV === "development" && (requestParameters.itemUuid === null || requestParameters.itemUuid === undefined)) {
                throw new runtime.RequiredError('itemUuid', 'Required parameter requestParameters.itemUuid was null or undefined when calling updateModelItem.');
            }
            if (process.env.NODE_ENV === "development" && (requestParameters.type === null || requestParameters.type === undefined)) {
                throw new runtime.RequiredError('type', 'Required parameter requestParameters.type was null or undefined when calling updateModelItem.');
            }
            if (process.env.NODE_ENV === "development" && (requestParameters.file === null || requestParameters.file === undefined)) {
                throw new runtime.RequiredError('file', 'Required parameter requestParameters.file was null or undefined when calling updateModelItem.');
            }
            if (process.env.NODE_ENV === "development" && (requestParameters.path === null || requestParameters.path === undefined)) {
                throw new runtime.RequiredError('path', 'Required parameter requestParameters.path was null or undefined when calling updateModelItem.');
            }
            const queryParameters = {};
            if (requestParameters.type !== undefined) {
                queryParameters['type'] = requestParameters.type;
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("oauthToken", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const consumes = [
                { contentType: 'multipart/form-data' },
            ];
            // @ts-ignore: canConsumeForm may be unused
            const canConsumeForm = runtime.canConsumeForm(consumes);
            let formParams;
            let useForm = false;
            // use FormData to transmit files using content-type "multipart/form-data"
            useForm = canConsumeForm;
            if (useForm) {
                formParams = new FormData();
            }
            else {
                formParams = new URLSearchParams();
            }
            if (requestParameters.file !== undefined) {
                formParams.append('file', requestParameters.file);
            }
            if (requestParameters.path !== undefined) {
                formParams.append('path', requestParameters.path);
            }
            if (requestParameters.fileTag !== undefined) {
                formParams.append('fileTag', requestParameters.fileTag);
            }
            const response = yield this.request({
                path: `/model/{modelUuid}/item/{itemUuid}`.replace(`{${"modelUuid"}}`, encodeURIComponent(String(requestParameters.modelUuid))).replace(`{${"itemUuid"}}`, encodeURIComponent(String(requestParameters.itemUuid))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: formParams,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Update specified model item
     */
    updateModelItem(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.updateModelItemRaw(requestParameters);
        });
    }
}
exports.ItemsApi = ItemsApi;
